import { dateTimeParts, timeParts } from "./format";

interface TimeCellProps {
  iso?: string;
  /** Time of day only, with seconds, for timelines within one run */
  timeOnly?: boolean;
  className?: string;
}

/** The viewer's local time, with UTC as subtext beneath it. Never truncated: a narrow column wraps instead. */
export default function TimeCell({ iso, timeOnly, className }: TimeCellProps) {
  const { local, utc } = timeOnly ? timeParts(iso) : dateTimeParts(iso);
  return (
    <div className={className}>
      <div>{local}</div>
      {utc && <div className="text-[13px] text-gray-500">{utc}</div>}
    </div>
  );
}
